import React from 'react';
import { initializeApp, getApps } from 'firebase/app';
import { initializeFirestore, getFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import firebaseConfig from './config';

const FirebaseContext = React.createContext(null);
export const useFirebase = () => React.useContext(FirebaseContext);

// Initialize Firebase app and Firestore only once
let app: any;
let db: any;

if (!getApps().length) {
    app = initializeApp(firebaseConfig);

    // Initialize Firestore with modern persistence API
    db = initializeFirestore(app, {
        localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager()
        })
    });

    getAnalytics(app);
} else {
    app = getApps()[0];
    db = getFirestore(app);
}

export function FirebaseProvider(props: any) {
    return (
        <FirebaseContext.Provider value={app}>
            {props.children}
        </FirebaseContext.Provider>
    );
}
